import PropTypes from 'prop-types';
import '../../styles/toggleCheckboxStyle.scss';

const ToggleCheckbox = ({id, checked, onChange, checkedLabel, uncheckedLabel}) => {
  return(
    <>
      <input type="checkbox" className="toggle" id={id} checked={checked}
        onChange={()=> onChange()} />
      <label htmlFor={id}>
        <span className="on">{checkedLabel? checkedLabel :'YES'}</span>
        <span className="off">{uncheckedLabel?uncheckedLabel:'NO'}</span>
      </label>
    </>
  );
};

ToggleCheckbox.propTypes={
  id:PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  checkedLabel: PropTypes.string,
  uncheckedLabel: PropTypes.string
};

export default ToggleCheckbox;